import { render, staticRenderFns } from "./LangMenu.vue?vue&type=template&id=3b8ea262"
import script from "./LangMenu.vue?vue&type=script&lang=ts"
export * from "./LangMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports